module.exports = __webpack_public_path__ + "static/media/avatar32.770700e5.png";